// extracted by mini-css-extract-plugin
export default {"container":"FormHeading_container__Ay0rs","heading":"FormHeading_heading__vLUF0","subHeading":"FormHeading_subHeading__tSdbw","closeButton":"FormHeading_closeButton__2Uzl3"};